(function($, BaseAPI) {
	"use strict";

	function formatMail(mail) {
		if (mail.caption)
			return mail.caption + ' <' + mail.email + '>';
		return mail.email;
	}

	function formatSize(size, lang) {
		if (typeof size !== 'number')
			return lang['SizeUnknown'];
		if (size >= 1024 * 1024)
			return lang['SizeMB'].replace('{0}', (size / 1024 / 1024).toFixed(1));
		if (size >= 1024)
			return lang['SizeKB'].replace('{0}', (size / 1024).toFixed(1));
		return lang['SizeB'].replace('{0}', size.toString());
	}

	function enhanceAttachments(attachments) {
		if (! $.fn.multiselect)
			return;
		// Application du plugin
		var select = attachments.multiselect({
			buttonClass: 'btn btn-link',
			buttonText: function(options, select) {
				if (options.length === 0)
					return '...';
				return options.get().map(function(option) {
					var self = $(option);
					var attachment = self.data('attachment');
					if (attachment)
						return attachment.name;
					return self.data('file').name;
				}).join(', ');
			}
		});
		// Ajustement du style (suppression du uppercase et alignement avec les autres inputs)
		select.closest('.col-md-8')
			.children('.multiselect-native-select').css('display', 'block').css('width', '100%')
			.children('.btn-group').css('width', '100%')
			.children('button').css({
				'padding': '6px 0',
				'text-transform': 'none',
				'max-width': '100%',
				'overflow': 'hidden',
				'text-overflow': 'ellipsis'
			})
			.children('.caret').css('margin', '0 6px');
	}

	function enhanceContacts(inputs, contacts, separator) {
		if (! $.fn.autocomplete)
			return;
		var list = contacts.map(function(contact) {
			return { value: contact.email, label: formatMail(contact) };
		});
		// Application du plugin
		inputs.autocomplete({
			minLength: 1, // pour que "*" fonctionne
			appendTo: inputs.closest('form')[0], // pour que le menu apparaisse bien
			source: function(request, response) {
				// On prend le dernier terme dans la liste séparée par ","
				var term = request.term.split(separator).pop();
				if (term === '*')
					response(list); // '*' = tous les résultats
				else if (!term || term.length < 2)
					response([]); // '' ou trop court, aucun résultat
				else {
					term = term.toLowerCase(); // recherche du terme
					response(list.filter(function(e) {
						return e.label.toLowerCase().indexOf(term) >= 0;
					}));
				}
			},
			focus: function() {
				// prevent value inserted on focus
				return false;
			},
			select: function( event, ui ) {
				var terms = this.value.split(separator);
				terms.pop();
				terms.push(ui.item.label);
				this.value = terms.join(separator) + separator;
				return false;
			}
		});
	}

	function enhanceEditor(textarea, language) {
		if (! ('CKEDITOR' in window))
			return;
		BaseAPI.ckeditorCreate(textarea[0], true, {
			language: language,
			// retiré car ne sert à rien mais en plus crée une scrollbar sous chrome en passant puis en quittant le mode maximisé
			// height: '100%'
			on: {
				change: function(evt) {
					evt.editor.updateElement();
				}
			},
		});
	}

	function normalizeEmails(contacts, contactSeparator) {
		var emails = contacts + contactSeparator;
		return emails.split(contactSeparator)
			.filter(function(m) { 
				return m && m.includes("@");})
			.map(function(m) {
				var indexOfLeftSeparator = m.indexOf("<");
				var indexOfRightSeparator = m.indexOf(">");
				var address = (indexOfLeftSeparator !== -1 && indexOfRightSeparator !== -1)
					? m.substring(indexOfLeftSeparator + 1, indexOfRightSeparator)
					: m;
				return address.trim();
			})
			.join();
	}

	function isGreaterThanMax(options, constraintName, value, transformValue) {
		var maxLen = options[constraintName];
		if (maxLen && value && value.length !== 0) {
			var valueToCheck = transformValue ? transformValue(value, options.contactSeparator) : value;
			var len = valueToCheck.length;
			return len > maxLen;
		}
		return false;
	}

	/**
	 * Ce plugin crée un popin permettant de saisir un mail
	 */
	$.fn.materialPopinMail = function(options) {
		// Injection des options par défaut
		options = $.extend({}, $.fn.materialPopinMail.defaultOptions, options);

		// Récupération de la langue
		var lang = $.fn.materialPopinMail.langs[options.lang];
		
		// droit de modification
		var canModify = options.canModify;

		// Création du template
		var template = $(''
				+ '<form id="material-mail-form" class="form-horizontal">'
				+ '  <div class="form-group">'
				+ '    <label for="material-mail-from" class="col-md-3 control-label">' + lang['From'] + '</label>'
				+ '    <div class="col-md-9"><select id="material-mail-from" class="form-control"></select></div>'
				+ '  </div>'
				+ '  <div class="form-group">'
				+ '    <label for="material-mail-send-to" class="col-md-3 col-xs-12 control-label">' + lang['SendTo'] + '</label>'
				+ '    <div class="col-md-8 col-xs-10"><input id="material-mail-send-to" type="text" class="form-control" value="" /><p class="form-control-static"></p></div>'
				+ '    <button type="button" id="material-mail-send-to-button" class="col-md-1 col-xs-2 btn btn-link select-contacts"><i class="material-icons">add</i></button>'
				+ '  </div>'
				+ '  <div class="form-group">'
				+ '    <label for="material-mail-send-cc" class="col-md-3 col-xs-12 control-label">' + lang['SendCC'] + '</label>'
				+ '    <div class="col-md-8 col-xs-10"><input id="material-mail-send-cc" type="text" class="form-control" value="" /><p class="form-control-static"></p></div>'
				+ '    <button type="button" id="material-mail-send-cc-button" class="col-md-1 col-xs-2 btn btn-link select-contacts"><i class="material-icons">add</i></button>'
				+ '  </div>'
				+ '  <div class="form-group">'
				+ '    <label for="material-mail-send-bcc" class="col-md-3 col-xs-12 control-label">' + lang['SendBCC'] + '</label>'
				+ '    <div class="col-md-8 col-xs-10"><input id="material-mail-send-bcc" type="text" class="form-control" value="" /><p class="form-control-static"></p></div>'
				+ '    <button type="button" id="material-mail-send-bcc-button" class="col-md-1 col-xs-2 btn btn-link select-contacts"><i class="material-icons">add</i></button>'
				+ '  </div>'
				+ '  <div class="form-group">'
				+ '    <label for="material-mail-reply-to" class="col-md-3 col-xs-12 control-label">' + lang['ReplyTo'] + '</label>'
				+ '    <div class="col-md-8 col-xs-10"><input id="material-mail-reply-to" type="text" class="form-control" value="" /><p class="form-control-static"></p></div>'
				+ '    <button type="button" id="material-mail-reply-to-button" class="col-md-1 col-xs-2 btn btn-link select-contacts reply-to"><i class="material-icons">add</i></button>'
				+ '  </div>'
				+ '  <div class="form-group">'
				+ '    <label for="material-mail-subject" class="col-md-3 control-label">' + lang['Subject'] + '</label>'
				+ '    <div class="col-md-9"><input id="material-mail-subject" type="text" class="form-control" value="" required="required" /></div>'
				+ '  </div>'
				+ '  <div class="form-group">'
				+ '    <label for="material-mail-attachments" class="col-md-3 col-xs-12 control-label">' + lang['Attachments'] + '</label>'
				+ '    <div class="col-md-8 col-xs-10"><select id="material-mail-attachments" class="form-control" multiple="multiple"><select></div>'
				+ '    <button type="button" id="material-mail-attachments-button" class="col-md-1 col-xs-2 btn btn-link"><i class="material-icons">add</i></button>'
				+ '    <input type="file" id="material-mail-attachments-input" style="display: none;" />'
				+ '  </div>'
				+ '  <div><textarea id="material-mail-content" class="form-control" value="" required="required" placeholder="' + lang['Content'] + '"></textarea></div>'
				+ '</form>'
				+ '');
		template.css('display', 'flex').css('flex-direction', 'column').css('height', '100%');
		template.find('>.form-group').css('margin', '0').css('flex', '0 0 auto');
		template.find('>div:last-child').css('flex', '1 1 auto');
		template.find('>.form-group>.control-label').css('padding-right', '15px');

		var from = template.find('#material-mail-from');
		var sendTo = template.find('#material-mail-send-to');
		var sendToButton = template.find('#material-mail-send-to-button');
		var sendCC = template.find('#material-mail-send-cc');
		var sendCCButton = template.find('#material-mail-send-cc-button');
		var sendBCC = template.find('#material-mail-send-bcc');
		var sendBCCButton = template.find('#material-mail-send-bcc-button');
		var replyTo = template.find('#material-mail-reply-to');
		var replyToButton = template.find('#material-mail-reply-to-button');
		var subject = template.find('#material-mail-subject');
		var content = template.find('#material-mail-content');
		var attachments = template.find('#material-mail-attachments');
		var attachmentsButton = template.find('#material-mail-attachments-button');
		var attachmentsInput = template.find('#material-mail-attachments-input');

		// De
		from.append(options.froms.map(function(from, index) {
			return $('<option />').attr('value', from.email).text(formatMail(from)).prop('selected', index === options.fromIndex)[0];
		}));
		from.closest('.form-group').toggle(options.canChangeFromIndex && (options.froms.length >= 2));

		// Pour
		sendTo.val(options.sendTo).toggle(options.sendToModifiable);
		sendTo.next('.form-control-static').text(options.sendToLocked).toggle(!!options.sendToLocked);
		sendTo.closest('.form-group').toggle(options.sendToModifiable || !!options.sendToLocked);
		sendTo.prop('disabled', !canModify);
		sendToButton.toggle(canModify && !!options.onaddContacts);

		// Copie à
		sendCC.val(options.sendCC).toggle(options.sendCCModifiable);
		sendCC.next('.form-control-static').text(options.sendCCLocked).toggle(!!options.sendCCLocked);
		sendCC.closest('.form-group').toggle(options.sendCCModifiable || !!options.sendCCLocked);
		sendCC.prop('disabled', !canModify);
		sendCCButton.toggle(canModify && !!options.onaddContacts);

		// Copie cachée à
		sendBCC.val(options.sendBCC).toggle(options.sendBCCModifiable);
		sendBCC.next('.form-control-static').text(options.sendBCCLocked).toggle(!!options.sendBCCLocked);
		sendBCC.closest('.form-group').toggle(options.sendBCCModifiable || !!options.sendBCCLocked);
		sendBCC.prop('disabled', !canModify);
		sendBCCButton.toggle(canModify && !!options.onaddContacts);

		// Réponse à
		replyTo.val(options.replyTo).toggle(options.replyToModifiable);
		replyTo.next('.form-control-static').text(options.replyToLocked).toggle(!!options.replyToLocked);
		replyTo.closest('.form-group').toggle(options.replyToModifiable || !!options.replyToLocked);
		replyTo.prop('disabled', !canModify);
		replyToButton.toggle(canModify && !!options.onaddContacts);

		// Pièces jointes
		attachments.append(options.attachments.map(function(attachment, index) {
			var size = formatSize(attachment.size, lang);
			var option = $('<option />').data('attachment', attachment).attr('value', attachment.name + size).text(attachment.name);
			option.append('<span style="font-size: small; opacity: 0.7; ">' + size + '</span>');
			option.prop('selected', attachment.selected).prop('disabled', attachment.required || !canModify);
			return option[0];
		}));
		attachments.closest('.form-group').toggle(canModify && (options.canAddAttachments || (options.attachments.length > 0)));

		// Ajout de PJ
		attachmentsButton.toggle(options.canAddAttachments && canModify).on('click', function() {
			attachmentsInput.click();
		});
		attachmentsInput.on('change', function(event) {
			var files = attachmentsInput[0].files;
			if (files.length === 0)
				return;
			var option = $('<option />').data('file', files[0]).text(files[0].name);
			option.append('<span style="font-size: small; opacity: 0.7; ">' + formatSize(files[0].size, lang) + '</span>');
			option.prop('selected', true);
			attachments.append(option);
			if ($.fn.multiselect)
				attachments.multiselect('rebuild');
		});

		// Sujet
		subject.val(options.subject).prop('disabled', !(options.canChangeSubject && canModify));

		// Contenu
		content.val(options.content).prop('disabled', !(options.canChangeContent && canModify)).css('height', '100%');

		// Amélioration de la saisie via des plugins jQuery tiers
		enhanceContacts(template.find('#material-mail-send-to,#material-mail-send-cc,#material-mail-send-bcc'), options.contacts, options.contactSeparator);
		enhanceAttachments(attachments);
		enhanceEditor(content, options.lang);

		if (options.onaddContacts && canModify) {
			template.find('.select-contacts').show().click(function(event) {
				var selectContactsButton = $(event.target).closest('.select-contacts');
				var input = selectContactsButton.closest('.form-group').find('input');
				var currentValue = input.val();
				var currentSelectedContactMails = currentValue.split(options.contactSeparator).map(function(mail) {
					// Transforme les mail NOM <mail> en mail
					var startIndex = mail.lastIndexOf('<');
					if (startIndex  !== -1)
						return mail.substring(startIndex + 1, mail.lastIndexOf('>'));
					return mail;
				});

				var notSelectedContacts = options.contacts.filter(function(contact) {
					return !currentSelectedContactMails.includes(contact.email);
				});
				
				if (selectContactsButton.hasClass('reply-to')) {
					notSelectedContacts = notSelectedContacts.concat(options.froms);
				}

				options.onaddContacts(notSelectedContacts).then(function(newSelectedContacts) {
					var newSelectedContactMails = newSelectedContacts.map(function(contact) {
						return contact.email;
					}).join(options.contactSeparator);
					if (currentValue.length === 0)
						input.val(newSelectedContactMails);
					else if (currentValue.length > 0 && newSelectedContactMails.length > 0)
						input.val(currentValue + options.contactSeparator + newSelectedContactMails);
				});
			});
		}

		// Affichage du popin une fois que tout est prêt
		$(this).css('height', '100%').append(template).materialPopin({
			title: lang['Title'],
			closeButtonTitle: lang['CancelButton'],
			buttons : [{
				icon : 'done',
				visible : options.canSendMail,
				title: lang['SendButton'],
				onclickPromise : function validate() {
					// Préparation du mail
					var mail = new $.fn.materialPopinMail.Mail();
					mail.from = from.val();
					mail.sendTo = sendTo.val() + options.contactSeparator + options.sendToLocked;
					mail.sendCC = sendCC.val() + options.contactSeparator + options.sendCCLocked;
					mail.sendBCC = sendBCC.val() + options.contactSeparator + options.sendBCCLocked;
					mail.replyTo = replyTo.val() + options.contactSeparator + options.replyToLocked;
					mail.subject = subject.val();
					mail.content = content.val();
					mail.contentIsHTML = true;
					mail.files = attachments.children(':selected').map(function() {
						return $(this).data('file');
					}).get();
					mail.attachments = attachments.children(':selected').map(function() {
						return $(this).data('attachment');
					}).get();

					// Vérification du formulaire
					var mailErrorOnContact = mail.sendTo.replace(options.contactSeparator, '').length === 0 
						|| isGreaterThanMax(options, 'sendToMaxLength', mail.sendTo, normalizeEmails);
					var mailErrorOnSubject = !mail.subject || isGreaterThanMax(options, 'subjectMaxLength', mail.subject);
					var mailErrorOnContent = !mail.content || isGreaterThanMax(options, 'contentMaxLength', mail.content);
					var mailErrorOnSendCC = mail.sendCC && isGreaterThanMax(options, 'sendCCMaxLength', mail.sendCC, normalizeEmails);
					var mailErrorOnSendBCC = mail.sendBCC && isGreaterThanMax(options, 'sendBCCMaxLength', mail.sendBCC, normalizeEmails);
					var mailErrorOnReplyTo = mail.replyTo && isGreaterThanMax(options, 'replyToMaxLength', mail.replyTo, normalizeEmails);

					sendTo.closest('.form-group').toggleClass('has-error', mailErrorOnContact);
					subject.closest('.form-group').toggleClass('has-error', mailErrorOnSubject);
					sendCC.closest('.form-group').toggleClass('has-error', mailErrorOnSendCC);
					sendBCC.closest('.form-group').toggleClass('has-error', mailErrorOnSendBCC);
					replyTo.closest('.form-group').toggleClass('has-error', mailErrorOnReplyTo);

					content.parent().find('.cke').css('border-color', mailErrorOnContent ? 'red' : '');
					if (mailErrorOnContact || mailErrorOnSubject || mailErrorOnContent
					|| mailErrorOnSendCC || mailErrorOnSendBCC || mailErrorOnReplyTo)
						return $.Deferred().reject();

					// Ajout de la signature si besoin
					if (options.addSignature) {
						var signature = options.froms[from[0].selectedIndex].signature;
						if (signature)
							mail.content += '<br />' + signature;
					}
					// Envoi du mail et fermeture auto (sauf en cas d'erreur)
					return options.execute(mail).fail(function(error) {
						options.error(lang.errors[error] || error);
					});
				}
			}]
		});
	};

	/** La classe représentant le mail saisi par l'utilisateur quand il valide le popin */
	$.fn.materialPopinMail.Mail = function() {
		this.from = '';
		this.sendTo = '';
		this.sendCC = '';
		this.sendBCC = '';
		this.replyTo = '';
		this.subject = '';
		this.content = '';
		this.contentIsHTML = true;
		this.files = [];
		this.attachments = [];
	};

	/** Traduction des libellés utilisés dans les différentes langues supportées */
	$.fn.materialPopinMail.langs = {
		fr: {
			Title: 'Mail',
			SendButton: 'Envoyer',
			CancelButton: 'Annuler',
			CancelConfirmation: 'Toutes les modifications seront perdues. Êtes-vous sûr ?',
			From: 'De',
			SendTo: 'Pour',
			SendCC: 'Copie à',
			SendBCC: 'Copie cachée à',
			ReplyTo: 'Réponse à',
			Subject: 'Sujet',
			Content: 'Contenu',
			Attachments: 'Pièces jointes',
			AttachmentsAdd: 'Ajouter une pièce jointe',
			SizeUnknown: ' (inconnue)',
			SizeB: ' ({0}&nbsp;octets)',
			SizeKB: ' ({0}&nbsp;Ko)',
			SizeMB: ' ({0}&nbsp;Mo)',
			errors: {
				MailErrorNoContact: 'Aucun destinataire n\'est sélectionné.',
				MailErrorNoSubject: 'Le sujet est vide.',
				MailErrorNoContent: 'Le contenu est vide.',
				MailErrorIncorrectAddress: 'Adresse e-mail incorrecte',
				MailErrorUnexpected: 'Une erreur inattendue est survenue. L\'envoi n\'a pas eu lieu.',
			},
		},
		en: {
			Title: 'Mail',
			SendButton: 'Send',
			CancelButton: 'Cancel',
			CancelConfirmation: 'All modifications will be lost. Are you sure you want to close this window ?',
			From: 'From',
			SendTo: 'To',
			SendCC: 'CC to',
			SendBCC: 'BCC to',
			ReplyTo: 'Reply to',
			Subject: 'Subject',
			Content: 'Content',
			Attachments: 'Attachments',
			AttachmentsAdd: 'Add attachment',
			SizeUnknown: ' (unknown)',
			SizeB: ' ({0}&nbsp;bytes)',
			SizeKB: ' ({0}KB)',
			SizeMB: ' ({0}MB)',
			errors: {
				MailErrorNoContact: 'No contact selected.',
				MailErrorNoSubject: 'Subject is empty.',
				MailErrorNoContent: 'Content is empty.',
				MailErrorIncorrectAddress: 'Incorrect email address.',
				MailErrorUnexpected: 'An error occurred. Could not send the mail.',
			},
		},
		de: {
			Title: 'Mail',
			SendButton: 'Absenden',
			CancelButton: 'Abbrechen',
			CancelConfirmation: 'Alle Änderungen gehen verloren. Sind Sie sicher?',
			From: 'Absender',
			SendTo: 'Empfänger',
			SendCC: 'Kopie an',
			SendBCC: 'Blindkopie an',
			ReplyTo: 'Antworten auf',
			Subject: 'Betreff',
			Content: 'Inhalt',
			Attachments: 'Anhänge',
			AttachmentsAdd: 'Anhang hinzufügen',
			SizeUnknown: ' (unbekannt)',
			SizeB: ' ({0}&nbsp;Bytes)',
			SizeKB: ' ({0}&nbsp;Kb)',
			SizeMB: ' ({0}&nbsp;Mb)',
			errors: {
				MailErrorNoContact: 'Kein Empfänger ausgewählt.',
				MailErrorNoSubject: 'Der Betreff ist leer.',
				MailErrorNoContent: 'Der Inhalt ist leer.',
				MailErrorIncorrectAddress: 'Mail-Adresse verkehrt.',
				MailErrorUnexpected: 'Ein unerwarteter Fehler ist aufgetreten. Der Versand ist nicht erfolgt.',
			},
		}
	};

	/** Options par défaut pour la construction du popin de mail */
	$.fn.materialPopinMail.defaultOptions = {
		lang: 'fr',

		froms: [], // email, caption, signature
		fromIndex: 0,
		canChangeFromIndex: true,

		contacts: [], // email, caption
		contactSeparator: ';',

		sendTo: '',
		sendToModifiable: true,
		sendToLocked: '',

		sendCC: '',
		sendCCModifiable: true,
		sendCCLocked: '',

		sendBCC: '',
		sendBCCModifiable: true,
		sendBCCLocked: '',

		replyTo: '',
		replyToModifiable: true,
		replyToLocked: '',

		attachments: [], // name, size, required?, selected?, ...(type, attachmentId, templateName)
		canAddAttachments: true,

		subject: '',
		canChangeSubject: true,

		content: '',
		canChangeContent: true,

		addSignature: true,
		
		canModify: true,
		canSendMail: true,

		execute: function(mail) {
			return $.Deferred().resolve(mail);
		},
		error: function(text) {
			window.alert(text);
		}
	};

})(window.jQuery, window.BaseAPI);